import { Component, OnInit } from '@angular/core';
import { StopsStationsInterface } from '../map/map.component';
import { BusService } from '@app/shared/services/bus.service';
import { first } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment-timezone';
import { BusInterface } from '@app/shared/models/bus.model';
import { MatSelectChange } from '@angular/material/select';
import { RatesService } from '../../shared/services/rates.service';
import { Rates } from '@app/shared/models/rates.model';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'ty-rates',
  templateUrl: './rates.component.html',
  styleUrls: ['./rates.component.scss'],
})


export class RatesComponent implements OnInit {
  //TODO on init de la app / on init
  allStations!: StopsStationsInterface[];
  origen: FormGroup;
  destino: FormGroup;
  listOfBus!: BusInterface[];
  selectedLine: string;
  ratesLine!: Rates[];
  SpinnerSearch = false;

  constructor(
    private busService: BusService,
    private logger: NGXLogger,
    private _formBuilder: FormBuilder,
    private ratesService: RatesService,
    private snackBar: MatSnackBar,
  ) {
    const dateActual = new Date().getFullYear();
    this.origen = this._formBuilder.group({secondCtrl: ['', Validators.required]});
    this.destino = this._formBuilder.group({thirdCtrl: ['', Validators.required]});
    this.selectedLine = '';
  }

  ngOnInit(): void {
    this.getAllBusStops();
    this.getBusList();
  }

  getAllBusStops(): void {
    this.busService
      .getListOfAllStops()
      .pipe(first())
      .subscribe(
        (res: StopsStationsInterface[]) => {
          this.allStations = res.sort((a,b) => {
            if (a.stop_name! < b.stop_name!){
              return -1;
            }
            if (a.stop_name! > b.stop_name!){
              return 1;
            }
            return 0;
          });
        },
        (error: Error) => {
          this.logger.error(`MapComponent.getAllBusStops=> ${error}`);
          this.snackBar.open('Error al cargar las paradas, inténtalo más tarde', 'Aceptar', { duration: 6000});
          throw error;
        }
      );
  }

  getBusList(): void {
    this.busService.getBusList().pipe(first()).subscribe((res: BusInterface[]) => {
      this.listOfBus = res;
    },
      (err) => {
        this.logger.error(`Error al cargar los autobuses en: bus.component.ts GetBusList() ${err.message}`);
        this.snackBar.open('Error al cargar los buses, espera unos minutos', 'Aceptar', { duration: 6000});
      });
  }

  calculate(): void {
    let paradaOrigen = '';
    let paradaDestino = '';

    if (this.destino.pristine) {
      this.origen.markAsTouched();
      this.destino.markAsTouched();

    } else {
    // TODO: Arreglar el formato de datos segun donde lo pase
      paradaOrigen = this.origen.value;
      paradaDestino = this.destino.value;

    // TODO: Llamadas

      console.log(paradaOrigen, "Origen");
      console.log(paradaDestino, "Destino");
    }
  }

  clean(): void {
    this.origen.reset();
    this.destino.reset();
  }

  getTarifaPorLinea(event: MatSelectChange): void {
    this.SpinnerSearch = true;
    this.selectedLine = event.value;
    this.ratesService.getTarifas(1,1,this.selectedLine).pipe(first()).subscribe(
      (res: Rates[]) => {
        this.SpinnerSearch = false;
        this.ratesLine = res;
      },
      (err) => {
        this.SpinnerSearch = false;
        this.logger.error(`Error al cargar los precios en: getTarifaPorLinea ${err.message}`);
        this.snackBar.open('Error al cargar las tarifas, prueba en unos minutos', 'Aceptar', { duration: 6000});
      }
    );

  }
}
